import scrollingDates from '../modules/scrolling-dates';

export default {
  init() {},
  finalize() {
    scrollingDates();
  },
};
